export default {
  SEARCH_AGREEMENTS_REPOSITORY: Symbol.for('SEARCH_AGREEMENTS_REPOSITORY'),
  AGREEMENTS_STATE_MANAGER: Symbol.for('AGREEMENTS_STATE_MANAGER'),
  SEARCH_AGREEMENTS_QUERY: Symbol.for('SEARCH_AGREEMENTS_QUERY'),
  SEARCH_AGREEMENTS_ASYNC_QUERY: Symbol.for('SEARCH_AGREEMENTS_ASYNC_QUERY'),
};
